



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Store } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreMessagingPage extends Base {
  public store: Store = {};
  public form: any = {};
  public storeMessagingFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('storeMessaging.btnBackToListTitle'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('storeMessaging.btnBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setMessagingFields();
    if (this.$route.params.storeId) {
      this.getStore(this.$route.params.storeId);
    }
  }

  public setMessagingFields(): void {
    this.storeMessagingFields = [
      {
        key: 'isMessagingEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('storeMessaging.IsMessagingEnabled') as string,
          validations: '',
          loading: false,
        },
      },
      {
        key: 'messagingNumber',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$parent.$t('storeMessaging.messagingPhone') as string,
          validations: '',
          loading: false,
        },
      },
      {
        key: 'isStoreTeamEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$parent.$t(
            'storeMessaging.isStoreTeamsEnabled'
          ) as string,
          validations: '',
          loading: false,
        },
      },
    ];
  }

  public async getStore(storeId: string): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeMessagingFields);
      const response = await storeService.getStore(Number(storeId));
      this.store = response;
    } finally {
      this.formlyHideSkeleton(this.storeMessagingFields);
    }
  }

  public saveStoreMessaging(): void {
    // Save Store Messaging
  }

  public backToList() {
    this.$router
      .push({
        name: 'admin.stores.edit',
        params: { id: this.storeId.toString() },
      })
      .catch((ex) => {console.log(ex);});
  }
}
